import React from "react";
import { Loader2, RefreshCw, Mail, Download, Unlock } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { Stat, btnGhost } from "@/components/Brand";

/** Photo counters + drive resync. */
export const ProjectStats = ({ project, summary, busy, onSync }) => {
  const { t } = useI18n();
  const s = summary;

  return (
    <div className="border border-[#2A2A2A] bg-[#0F0F0F] p-6">
      <p className="eyebrow mb-5">{t("photos")}</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-3">
        <Stat label={t("photos")} value={project.photos?.length || 0} testId="stat-photos" />
        <Stat label={t("edits")} value={`${s.edit_count - s.extra_edit_count}/${project.edit_quota}`} testId="stat-edits" />
        <Stat label={t("extra")} value={s.extra_edit_count} testId="stat-extra" accent={s.extra_edit_count > 0} />
        <Stat label={t("prints")} value={s.print_count} testId="stat-prints" />
      </div>
      <button data-testid="sync-drive-btn" disabled={busy === "sync"} onClick={onSync}
        className={`${btnGhost} w-full mt-6 py-3`}>
        {busy === "sync" ? <Loader2 size={13} className="animate-spin" /> : <RefreshCw size={13} />} {t("resync")}
      </button>
    </div>
  );
};

/** PDF download, email summary and reopen. */
export const ProjectActions = ({ project, pdfHref, busy, onEmail, onReopen }) => {
  const { t } = useI18n();

  return (
    <div className="border border-[#2A2A2A] bg-[#0F0F0F] p-6 space-y-4">
      <p className="eyebrow">{t("summary")}</p>
      <a data-testid="download-pdf-btn" href={pdfHref} className={`${btnGhost} w-full py-3`}>
        <Download size={13} /> {t("download_pdf")}
      </a>
      <button data-testid="email-summary-btn" disabled={busy === "email"} onClick={onEmail}
        className={`${btnGhost} w-full py-3`}>
        {busy === "email" ? <Loader2 size={13} className="animate-spin" /> : <Mail size={13} />} {t("email_summary")}
      </button>
      {project.status === "submitted" && (
        <button data-testid="reopen-project-btn" disabled={busy === "reopen"} onClick={onReopen}
          className={`${btnGhost} w-full py-3`}>
          <Unlock size={13} /> {t("reopen")}
        </button>
      )}
    </div>
  );
};
